var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7vxokhkwpa",
    d: "M9.93 1.853c-.093-.159-.227-.29-.39-.382-.503-.282-1.144-.112-1.432.38L1.503 13.128c-.091.156-.139.332-.139.51 0 .568.47 1.027 1.05 1.027h13.172c.182 0 .361-.046.52-.134.503-.281.679-.908.392-1.4L9.93 1.852zm.288-1.54c.374.21.684.513.897.88l6.568 11.277c.66 1.133.256 2.575-.902 3.22-.364.203-.776.31-1.195.31H2.413C1.081 16 0 14.943 0 13.639c0-.412.11-.817.32-1.174L6.923 1.188C7.587.056 9.062-.335 10.218.313zm-1.22 11.272c-.522 0-.945.414-.945.924s.423.924.944.924c.522 0 .945-.413.945-.924 0-.51-.423-.924-.945-.924zm0-7.186c-.406 0-.735.329-.735.734v4.691c0 .406.329.735.734.735.406 0 .735-.329.735-.735v-4.69c0-.406-.33-.735-.735-.735z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184 -218) translate(40 218) translate(147 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#7vxokhkwpa"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e6c61e07.svg";
export { ForwardRef as ReactComponent };